"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidUrl = void 0;

var isValidUrl = function isValidUrl(urlString) {
  var urlPattern = new RegExp('(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?'); // validate fragment locator

  return !!urlPattern.test(urlString);
};

exports.isValidUrl = isValidUrl;